import { render, staticRenderFns } from "./BriefContentView.vue?vue&type=template&id=4ddd3637&scoped=true"
import script from "./BriefContentView.vue?vue&type=script&lang=js"
export * from "./BriefContentView.vue?vue&type=script&lang=js"
import style0 from "./BriefContentView.vue?vue&type=style&index=0&id=4ddd3637&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddd3637",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ddd3637')) {
      api.createRecord('4ddd3637', component.options)
    } else {
      api.reload('4ddd3637', component.options)
    }
    module.hot.accept("./BriefContentView.vue?vue&type=template&id=4ddd3637&scoped=true", function () {
      api.rerender('4ddd3637', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/BriefContentView.vue"
export default component.exports